import React from 'react';
import {observer, inject} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Glyphicon, Table} from 'react-bootstrap';
import ActivityDate from './ActivityDate'
import {LinkContainer} from 'react-router-bootstrap';
import InfiniteScroll from 'react-infinite-scroller';


@injectIntl @inject("rootStore") @observer
export default class ActivitiesList extends React.Component {

    constructor(props) {
        super(props);
        this.handleLoadMore = this.handleLoadMore.bind(this);
    }

    render() {
        const activities = this.props.rootStore.activityStore.activities;
        const sortedActivities = activities.sort((a, b) =>
            new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
        );
        const activitiesCount = this.props.rootStore.activityStore.activitiesCount;
        const hasMoreItems = this.props.rootStore.activityStore.hasMoreItems;
        return (
            <div>
                {this.renderActivitiesOrEmptyMessage(sortedActivities, hasMoreItems, activitiesCount)}
            </div>
        );
    }

    renderActivitiesOrEmptyMessage(activities, hasMoreItems, activitiesCount) {
        const {intl, rootStore} = this.props;
        if (activities.length > 0) {
            return (
                <div>
                    <h3 className="text-center bold">{intl.formatMessage({id: "activities"}) + " "}({activitiesCount})</h3>
                    <br/>
                    <div className="activities-scroll">
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={this.handleLoadMore}
                            hasMore={hasMoreItems}
                            loader={<div key={0} className="loader">...</div>}
                            useWindow={false}
                        >
                            <Table striped bordered hover>
                                <tbody>
                                {activities.map((activity, idx) =>
                                    <tr key={idx}>
                                        <td>
                                            <LinkContainer to={rootStore.initialPath + activity.id}>
                                                <div className="activity-list-item">
                                                    <div className="">
                                                        <div className="media-title">
                                                            <h4>
                                                                {activity.activityName}
                                                            </h4>
                                                        </div>
                                                        <div className="description">
                                                            {activity.activityDescription}
                                                        </div>
                                                    </div>
                                                    <ActivityDate activity={activity}/>
                                                    {activity.place && (
                                                        <div>
                                                            <Glyphicon glyph="map-marker"/>&nbsp;&nbsp;
                                                            <span>{activity.place}&nbsp;</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </LinkContainer>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>
                        </InfiniteScroll>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="not-found-error">
                    {intl.formatMessage({id: "no_activities_list"})}
                </div>
            );
        }
    }

    handleLoadMore() {
        this.props.rootStore.activityStore.loadMoreActivities();
    }

}